var c324SliderCounter = 0;
var c324SliderInterval = null;

document.addEventListener('DOMContentLoaded', function() {
  /* CHECKMARKS */
  convertChecklists();
  
  /* MENU HOVER */
  let hoverTimeout = null;
  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  if (items) {
    items.forEach(item => {
      item.addEventListener("mouseover", () => {
        item.setAttribute("open", true);
        item.querySelector("ul").addEventListener("mouseleave", () => {
          setTimeout(() => { item.removeAttribute("open"); }, 500);
        }, {passive: true});

        item.addEventListener("mouseleave", () => {
          setTimeout(() => { item.removeAttribute("open"); }, 500);
        }, {passive: true});
      }, {passive: true});
    });
  }

  /* CART DRAWER / TOS */
  /* let agree = document.querySelector('#agree');
  let checkout = document.querySelector('#CartDrawer-Checkout');

  if (agree) {
    agree.addEventListener('click', function(e) {
      if (agree.checked) {
        checkout.disabled = false;
      } else {
        checkout.disabled = true;
      }
    });
  } */

  /* BACK TO TOP */
  let toTop = document.querySelector('#backToTop');

  if (toTop) {
    toTop.addEventListener('click', function(e) {
      e.preventDefault();
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    });

    window.addEventListener('scroll', handleScroll, {passive: true});
  }

  
  /* GRADE / CERTIFICATION JS */
  let gradeButton = document.querySelector('.grade');

  if (gradeButton) {
    /* Handle links from the manual where we want the test open by default */
    if (window.location.href.includes("#!")) {
      toggleLayer('certificationTest');
      toggleLayer('grade');
    }

    gradeButton.type = 'button';
    gradeButton.addEventListener('click', gradeTest);
  }

  /* LOOK FOR SLIDERS TO ANIMATE */
  let sliderElement = document.querySelector('slider-component.slider-component-full-width.slider-component-desktop ul');
  let triggerElementAbove = null;
  let triggerElementBelow = null;

  if (sliderElement) {
    triggerElementAbove = sliderElement.closest('.shopify-section').previousSibling;

    if (sliderElement.closest('.shopify-section').nextSibling.offsetHeight) {
      triggerElementBelow = sliderElement.closest('.shopify-section').nextSibling;
    } else {
      triggerElementBelow = document.querySelector('footer.footer');
    }
  }

  if (sliderElement && triggerElementAbove && triggerElementBelow) {
    c324SliderInterval = animateSlider(sliderElement, triggerElementAbove, triggerElementBelow);
  }

  /* LOOK FOR EXTERNAL LINKS -- a la ES6 style */
  [...document.links].forEach(link => {
    if (link.hostname != window.location.hostname) { link.target = '_blank'; }
  });
});

function gradeTest() {
  var testResult = false;
  var numberRight = 0;
  var elementToScrollTo = '';

  for (var i=1; i <= answers.length; i++) {
    var radioArray = document.getElementsByName('question' + i);
    for (var j=0; j < radioArray.length; j++) {
      if (radioArray[j].checked) {
        if (String(radioArray[j].value).toLowerCase() == String(answers[i]).toLowerCase()) {
          var hintElement = document.getElementById('question' + i + 'Hint');
          hintElement.style.display = 'none'; numberRight++;
        }

        if (String(radioArray[j].value).toLowerCase() != String(answers[i]).toLowerCase()) {
          var hintElement = document.getElementById('question' + i + 'Hint');
          hintElement.style.display = 'block';

          if (elementToScrollTo == '') {
            elementToScrollTo = hintElement;
          }
        }
      }
    }
  }

  if (numberRight / (answers.length-1) < .7) {
    document.querySelector('#test-percentage-fail').innerHTML = Math.round(numberRight / (answers.length-1) *100);
    window.location.hash = 'grade-status-fail';
  } else {
    testResult = true;
    document.querySelector('#test-percentage-pass').innerHTML = Math.round(numberRight / (answers.length-1) *100);
    window.location.hash = 'grade-status-pass';

    document.querySelector('#completePurchase').addEventListener('click', function() {
      // For /cart page!
      document.querySelector('[data-type="add-to-cart-form"]').submit();

      // For cart drawer -- how should we handle?
      /* const payload = JSON.stringify({ id: document.querySelector('input[name="id"]').value, quantity: 1 });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: payload
      })
      .then(response => response.json())
      .then(updatedCart => {
        console.log(updatedCart);
        // const cartDrawer = document.querySelector('cart-drawer');
        // if (cartDrawer) {
          // cartDrawer.renderContents(updatedCart);
        // }
        // cartDrawer.open();

        // document.querySelector('cart-drawer-items').onCartUpdate();
        // document.querySelector('cart-drawer').open();
      })
      .catch(error => {
        console.log('Error adding to cart:', error);

        // document.querySelector('cart-drawer-items').onCartUpdate();
        // document.querySelector('cart-drawer').open();
      }); */
    }, false);

    
  }

  if (!testResult) {
    var testElement = document.getElementById('certificationTest');
    testElement.style.display = 'block';
    scrollToElement(elementToScrollTo);
  }

  return testResult;
}

function toggleLayer(selector) {
  var selectorElement = document.querySelector('#' + selector);

  if (!selectorElement) {
    selectorElement = document.querySelector('.' + selector);
  }

  var style = selectorElement.style;
  style.display = style.display ? "" : "block";

  return false;
}

function scrollToElement(elementToScrollTo) {
  window.scroll({ top: elementToScrollTo.offsetTop - 100, left: 0, behavior: 'smooth' });
}

function handleScroll() {
  let toTop = document.querySelector('#backToTop');

  if (document.documentElement.scrollTop > 1500) {
    toTop.classList.add('show');
  } else {
    toTop.classList.remove('show');
  }
}

function animateSlider(sliderElement, resetElementAbove, resetElementBelow) {
  clearInterval(c324SliderInterval);
  sliderElement.scroll(window.innerWidth/4*c324SliderCounter, 0);

  c324SliderInterval = setInterval(function () {
    if (c324SliderCounter >= 8) { c324SliderCounter = -1; }
    c324SliderCounter++;
    sliderElement.scroll(window.innerWidth/4*c324SliderCounter, 0);
  }, 2500);

  sliderElement.addEventListener('mouseover', (event) => {
    clearInterval(c324SliderInterval);

    if (resetElementAbove) {
      resetElementAbove.addEventListener('mouseover', (event) => {
        c324SliderInterval = animateSlider(sliderElement, resetElementAbove, resetElementBelow);
      }, {once: true});
    }

    if (resetElementBelow) {
      resetElementBelow.addEventListener('mouseover', (event) => {
        c324SliderInterval = animateSlider(sliderElement, resetElementAbove, resetElementBelow);
      }, {once: true});
    }
  }, {passive: true});

  sliderElement.addEventListener('touchstart', (event) => {
    clearInterval(c324SliderInterval);
  }, {passive: true});

  return c324SliderInterval;
}

/* FOR EXIT INTENT POPUP */
const CookieService = {
    setCookie(name, value, days) {
        let expires = '';

        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }

        document.cookie = name + '=' + (value || '')  + expires + ';';
    },

    getCookie(name) {
        const cookies = document.cookie.split(';');

        for (const cookie of cookies) {
            if (cookie.indexOf(name + '=') > -1) {
                return cookie.split('=')[1];
            }
        }

        return null;
    }
};

/* EXIT INTENT POPUP @ https://github.com/flowforfrank/exit-intent */
const popupPathArray = ['/', '/pages/asfa-fitness-affiliate-program', '/pages/asfa-endorsements', '/pages/frequently-asked-questions', '/pages/insurance', '/pages/partners', '/pages/success-stories', '/pages/terms-and-conditions'];

const exit = e => {
  const shouldExit =
    [...e.target.classList].includes('exit-intent-popup') || // user clicks on mask
    e.target.className === 'close' || // user clicks on the close icon
    e.keyCode === 27; // user hits escape

  if (shouldExit) {
    document.querySelector('.exit-intent-popup').classList.remove('visible');
  }
};

const mouseEvent = e => {
  const shouldShowExitIntent =
    !e.toElement &&
    !e.relatedTarget;

  if (shouldShowExitIntent) {
    document.removeEventListener('mouseout', mouseEvent);
    document.querySelector('.exit-intent-popup').classList.add('visible');

    CookieService.setCookie('exitIntentShown', true, 30);
  }
};

// Adding checks to make sure we only show popup on the pages we want them to
// basically protecting the funnel for collections/products/etc. 
if (!CookieService.getCookie('exitIntentShown') && (popupPathArray.includes(window.location.pathname) || (window.location.pathname.substring(1,6) == 'blogs'))) {
  setTimeout(() => {
      document.addEventListener('mouseout', mouseEvent);
      document.addEventListener('keydown', exit);
      document.querySelector('.exit-intent-popup').addEventListener('click', exit);
  }, 2000);
}

/* REFERSION TO TAPFILIATE CONVERSION */
let params = new URLSearchParams(document.location.search);
let rfsn = params.get("rfsn");

if (rfsn) {
  window.location.href = 'https://www.americansportandfitness.com?ref=' + rfsn.replace('.','-');
}

!function(){if(window&&window.Shopify){const a={add:"SCE:add",update:"SCE:update",change:"SCE:change",clear:"SCE:clear",mutate:"SCE:mutate"},c=["/cart/add","/cart/update","/cart/change","/cart/clear","/cart/add.js","/cart/update.js","/cart/change.js","/cart/clear.js"];if(window.fetch&&"function"==typeof window.fetch){const d=window.fetch;window.fetch=function(){const t=d.apply(this,arguments);return e(arguments[0])&&t.then(e=>{e.clone().json().then(t=>n(e.url,t))}),t}}if(window.XMLHttpRequest){const i=window.XMLHttpRequest.prototype.open;window.XMLHttpRequest.prototype.open=function(){const t=arguments[1];return this.addEventListener("load",function(){e(t)&&n(t,this.response)}),i.apply(this,arguments)}}function e(t){if(t)return t=t.split("/").pop(),c.includes("/cart/"+t)}function n(t,e){if("string"==typeof e)try{e=JSON.parse(e)}catch{}window.dispatchEvent(new CustomEvent(a.mutate,{detail:e}));t=!!(t=t)&&(t.includes("cart/add")?"add":t.includes("cart/update")?"update":t.includes("cart/change")?"change":!!t.includes("cart/clear")&&"clear");switch(t){case"add":window.dispatchEvent(new CustomEvent(a.add,{detail:e}));break;case"update":window.dispatchEvent(new CustomEvent(a.update,{detail:e}));break;case"change":window.dispatchEvent(new CustomEvent(a.change,{detail:e}));break;case"clear":window.dispatchEvent(new CustomEvent(a.clear,{detail:e}))}}}}();

window.addEventListener('SCE:add', (event) => {
  console.log(event.detail);
  document.querySelector('cart-drawer-items').onCartUpdate();
  document.querySelector('cart-drawer').open();
});

/* CUSTOM CHECKMARKS */
function convertChecklists(scopeSelector = '.rich-text__text.rte', root = document) {
  const CHECK = '✓';

  root.querySelectorAll(scopeSelector).forEach(container => {
    // Only inspect <p> elements inside the scoped container — not the whole document.
    container.querySelectorAll('p').forEach(p => {
      if (!p.textContent.includes(CHECK)) return;

      const groups = splitByBr(p);
      const fragment = document.createDocumentFragment();
      let currentChecklist = null;

      groups.forEach(nodes => {
        const text = nodes.map(n => n.textContent).join('').trim();
        const isCheckItem = text.startsWith(CHECK);

        if (isCheckItem) {
          stripLeadingCheckmark(nodes, CHECK);
        } else {
          currentChecklist = null; // non-checkmark line breaks the grouping run
        }

        const newP = document.createElement('p');
        const label = document.createElement('span');
        label.className = 'checklist__label';
        nodes.forEach(n => label.appendChild(n));
        newP.appendChild(label);

        if (isCheckItem) {
          if (!currentChecklist) {
            currentChecklist = document.createElement('div');
            currentChecklist.className = 'checklist';
            fragment.appendChild(currentChecklist);
          }
          currentChecklist.appendChild(newP);
        } else {
          fragment.appendChild(newP);
        }
      });

      p.replaceWith(fragment);
    });
  });

  // Split a <p>'s child nodes into groups, breaking at each <br>.
  function splitByBr(p) {
    const groups = [[]];
    Array.from(p.childNodes).forEach(node => {
      if (node.nodeName === 'BR') {
        groups.push([]);
      } else {
        groups[groups.length - 1].push(node);
      }
    });
    // Drop any empty leading/trailing groups (e.g. stray whitespace nodes).
    return groups.filter(group => group.some(n => n.textContent.trim().length));
  }

  // Remove the "✓" and following whitespace from the first text node in a group.
  function stripLeadingCheckmark(nodes, checkChar) {
    for (const node of nodes) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.includes(checkChar)) {
        node.textContent = node.textContent.replace(
          new RegExp(checkChar + '\\s*'), ''
        );
        break;
      }
    }
  }
}